import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import PhoneAndEmailInformation from '../PhoneAndEmailInformation';
import RadioButtonSelection from '../RadioButtonSelection';
import { connect } from 'react-redux';
import { USERINFO } from '../../../../data/reducer';
import ToolTip from '../../../../components/Tooltip';
import Notification from '../../../../components/Notification';

let { id: module_id } = module;

const EditHpaContact = (props) => {
  const {
    hpaContactInfo,
    handleChange,
    errors,
    setErrors,
    lastEdited,
    confirmFieldValues,
    handleConfirmField,
    savedContactInfo,
  } = props;

  const [showTooltip, toggleTooltip] = useState(false);

  return (
    <>
      <Notification>
        <FormattedMessage id={`${module_id}.hpa.confirmation`} tagName={'p'} />
      </Notification>
      <PhoneAndEmailInformation
        errors={errors}
        setErrors={setErrors}
        contactInfo={hpaContactInfo}
        setContactInfo={handleChange}
        lastEdited={lastEdited}
        confirmFieldValues={confirmFieldValues}
        handleConfirmField={handleConfirmField}
        moduleId={module_id}
        savedContactInfo={savedContactInfo}
      />
      <div className={'ot-collapsible-hpa-contacts-notifications-title'}>
        <FormattedMessage
          id={`${module_id}.hpa.notifications.title`}
          tagName={'p'}
        />
        <button
          data-mytip={`notification-tooltip`}
          style={{
            display: 'inline-block',
            padding: '2px',
            background: 'none',
            border: 'none',
          }}
          className="icon-info-sign"
          onMouseDown={(event) => {
            event.preventDefault();
          }}
          onMouseOver={() => {
            toggleTooltip(true);
          }}
          onMouseLeave={() => {
            toggleTooltip(false);
          }}
          onClick={() => toggleTooltip(!showTooltip)}
          onFocus={() => toggleTooltip(true)}
          onBlur={() => toggleTooltip(false)}
        />
        <ToolTip show={showTooltip} id={`notification-tooltip`}>
          <FormattedMessage id={'hpa.notifications.tooltip'}>
            {(txt) => <p>{txt}</p>}
          </FormattedMessage>
        </ToolTip>
      </div>

      <RadioButtonSelection
        notificationAgreement={hpaContactInfo.notificationAgreement}
        setNotificationAgreement={handleChange}
        moduleId={module_id}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    hpaContact: state[USERINFO],
  };
};

export default connect(mapStateToProps)(EditHpaContact);
